import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';
import './Pages.css';

const TermsOfService = () => {
  const { i18n } = useTranslation();
  const [openAccordion, setOpenAccordion] = useState(0);

  const toggleAccordion = (index) => {
    setOpenAccordion(openAccordion === index ? -1 : index);
  };

  const isEnglish = i18n.language === 'en';

  const termsData = [
    {
      title: isEnglish ? "1. General Overview" : "1. Përgjithësimi",
      content: isEnglish 
        ? `These terms of service govern the use of ShalaAccounting services. By accessing and using these services, you agree to comply with these terms in full.

ShalaAccounting offers professional accounting and financial consulting services for small and medium businesses in Kosovo. Our services include accounting, financial reporting, tax planning and business consulting.`
        : `Këto kushte të përdorimit rregullojnë përdorimin e shërbimeve të ShalaAccounting. Duke aksesuar dhe përdorur këto shërbime, ju pranoni të respektoni këto kushte në tërësi.

ShalaAccounting ofron shërbime profesionale kontabiliteti dhe konsulencë financiare për bizneset e vogla dhe të mesme në Kosovë. Shërbimet tona përfshijnë kontabilitet, raportim financiar, planifikim tatimor dhe konsulencë biznesi.`
    },
    {
      title: isEnglish ? "2. Our Services" : "2. Shërbimet tona",
      content: isEnglish
        ? `ShalaAccounting offers a wide range of accounting and financial services:

• Accounting and financial reporting
• Tax planning and optimization
• Business consulting and financial strategy
• Internal auditing and control
• Archive and documentation management
• Regulatory compliance consulting
• Financial analysis and management reporting
• Investment and business growth consulting

Each service is performed by certified professionals with extensive experience in accounting and finance.`
        : `ShalaAccounting ofron një gamë të gjerë shërbimesh kontabiliteti dhe financiare:

• Kontabilitet dhe raportim financiar
• Planifikim dhe optimizim tatimor
• Konsulencë biznesi dhe strategji financiare
• Auditim i brendshëm dhe kontroll
• Menaxhim i arkivit dhe dokumentacionit
• Konsulencë për rregulloret dhe përputhshmërinë
• Analiza financiare dhe raportim për menaxhimin
• Konsulencë për investime dhe rritje biznesi

Çdo shërbim kryhet nga profesionistë të certifikuar me eksperiencë të gjerë në fushën e kontabilitetit dhe financave.`
    },
    {
      title: isEnglish ? "3. Service Agreement" : "3. Marrëveshja e shërbimit",
      content: isEnglish
        ? `When you contact ShalaAccounting for services, a written agreement will be created that specifies:

• Specific services to be provided
• Pricing and payment terms
• Deadlines and obligations of the parties
• Confidentiality and data protection
• Cancellation and modification procedures

The agreement will be signed by both parties before services begin. Any changes to the agreement must be made with written consent from both parties.`
        : `Kur kontaktoni ShalaAccounting për shërbime, do të krijohet një marrëveshje e shkruar që përcakton:

• Shërbimet specifike që do të ofrohen
• Çmimet dhe kushtet e pagesës
• Afatet dhe detyrimet e palëve
• Konfidencialitetin dhe mbrojtjen e të dhënave
• Procedurat e anulimit dhe ndryshimit

Marrëveshja do të nënshkruhet nga të dy palët para fillimit të shërbimeve. Çdo ndryshim në marrëveshje duhet të bëhet me pëlqimin e shkruar të të dy palëve.`
    },
    {
      title: isEnglish ? "4. Confidentiality" : "4. Konfidencialiteti",
      content: isEnglish
        ? `ShalaAccounting places great importance on the confidentiality of our clients' information:

• All client information remains confidential
• We do not share data with third parties without written consent
• We use secure technology for data storage
• Our staff is bound by confidentiality agreements
• We maintain data according to applicable regulations

Exceptions to confidentiality include cases required by law or competent authorities.`
        : `ShalaAccounting i kushton rëndësi të madhe konfidencialitetit të informacionit të klientëve tanë:

• Të gjitha informacionet e klientit mbeten konfidenciale
• Nuk i ndajmë të dhënat me palë të treta pa pëlqimin e shkruar
• Përdorim teknologji të sigurt për ruajtjen e të dhënave
• Stafi ynë është i detyruar me marrëveshje konfidencialiteti
• Ruajmë të dhënat sipas rregulloreve të aplikueshme

Përjashtimet nga konfidencialiteti përfshijnë rastet kur kërkohet nga ligji ose autoritetet kompetente.`
    },
    {
      title: isEnglish ? "5. Payments and Pricing" : "5. Pagesat dhe çmimet",
      content: isEnglish
        ? `Our service prices are transparent and competitive:

• Prices are clearly communicated before services begin
• Payments are made according to the schedule specified in the agreement
• We accept cash, bank transfer and card payments
• Invoices are sent on time and contain all details
• Late payments may result in service interruption

We reserve the right to adjust prices with 30 days advance notice.`
        : `Çmimet e shërbimeve tona janë transparente dhe konkurruese:

• Çmimet komunikohen qartë para fillimit të shërbimeve
• Pagesat bëhen sipas orarit të përcaktuar në marrëveshje
• Pranojmë pagesa në para, transfer bankar dhe kartë
• Faturat dërgohen në kohë dhe përmbajnë të gjitha detajet
• Vonesat në pagesë mund të rezultojnë në ndërprerje të shërbimeve

Rezervojmë të drejtën për të rregulluar çmimet me njoftim paraprak 30 ditësh.`
    },
    {
      title: isEnglish ? "6. Liability and Warranty" : "6. Përgjegjësia dhe garancia",
      content: isEnglish
        ? `ShalaAccounting is responsible for the quality of services provided:

• We guarantee the accuracy and completeness of our work
• Our liability is limited to the amount of payment received
• We are not liable for indirect or consequential losses
• Clients must provide accurate and up-to-date information
• We reserve the right to refuse services in certain cases

In case of error on our part, we will correct without additional charge.`
        : `ShalaAccounting është përgjegjëse për cilësinë e shërbimeve të ofruara:

• Garantojmë saktësinë dhe plotësinë e punës sonë
• Përgjegjësia jonë është e kufizuar në shumën e pagesës së marrë
• Nuk jemi përgjegjës për humbje indirekte ose të pasqyruara
• Klientët duhet të ofrojnë informacione të sakta dhe të përditësuara
• Rezervojmë të drejtën për të refuzuar shërbime në raste të caktuara

Në rast gabimi nga ana jonë, do të korrigjojmë pa pagesë shtesë.`
    },
    {
      title: isEnglish ? "7. Agreement Termination" : "7. Përfundimi i marrëveshjes",
      content: isEnglish
        ? `The agreement may terminate under the following conditions:

• With written consent from both parties
• In case of serious breach of terms by the client
• In case of business closure or change of circumstances
• With 30 days advance notice from our side

After termination, the client must pay for services performed up to that date. All documents and information will be returned at the specified time.`
        : `Marrëveshja mund të përfundojë në kushtet e mëposhtme:

• Me pëlqimin e shkruar të të dy palëve
• Në rast shkelje të rëndë të kushteve nga klienti
• Në rast falje të biznesit ose ndryshim të rrethanave
• Me njoftim paraprak 30 ditësh nga ana jonë

Pas përfundimit, klienti duhet të paguajë për shërbimet e kryera deri në atë datë. Të gjitha dokumentet dhe informacionet do të kthehen në kohën e përcaktuar.`
    },
    {
      title: isEnglish ? "8. Applicable Law" : "8. Ligji i aplikueshëm",
      content: isEnglish
        ? `These terms of service are governed by the law of the Republic of Kosovo:

• Any disagreement will be resolved through negotiations
• In case of disagreement, Kosovar law will apply
• The competent court is that of Pristina
• Terms of service may be changed with advance notice
• Changes are communicated through our website

Continued use of services after terms change is considered acceptance.`
        : `Këto kushte të përdorimit rregullohen nga ligji i Republikës së Kosovës:

• Çdo mosmarrëveshje do të zgjidhet përmes negociatave
• Në rast mospajtimi, do të aplikohet ligji kosovar
• Gjykata kompetente është ajo e Prishtinës
• Kushtet e përdorimit mund të ndryshohen me njoftim paraprak
• Ndryshimet komunikohen përmes faqes sonë web

Përdorimi i vazhdueshëm i shërbimeve pas ndryshimit të kushteve konsiderohet pranim i tyre.`
    }
  ];

  return (
    <div className="terms-page">
      <div className="back-button-container">
        <Link to="/" className="back-button">
          ←
        </Link>
      </div>
      
      <div className="terms-container">
        <div className="terms-header">
          <h1>{isEnglish ? "Terms of Service" : "Kushtet e Përdorimit"}</h1>
          <p>ShalaAccounting - {isEnglish ? "Professional Accounting & Business Consulting Services" : "Shërbime Profesionale Kontabiliteti & Konsulencë Biznesi"}</p>
        </div>

        <div className="terms-content">
          <div className="terms-intro">
            <p>
              {isEnglish 
                ? "Welcome to ShalaAccounting. These terms of service define the relationships between us and our clients. By using our services, you agree to these terms."
                : "Mirë se vini në ShalaAccounting. Këto kushte të përdorimit përcaktojnë marrëdhëniet mes nesh dhe klientëve tanë. Duke përdorur shërbimet tona, ju pranoni këto kushte."
              }
            </p>
          </div>

          <div className="accordion-container">
            {termsData.map((item, index) => (
              <div key={index} className="accordion-item">
                <button
                  className={`accordion-header ${openAccordion === index ? 'active' : ''}`}
                  onClick={() => toggleAccordion(index)}
                >
                  <span className="accordion-title">{item.title}</span>
                  <span className="accordion-icon">
                    {openAccordion === index ? '−' : '+'}
                  </span>
                </button>
                <div className={`accordion-content ${openAccordion === index ? 'open' : ''}`}>
                  <div className="accordion-text">
                    {item.content.split('\n').map((paragraph, pIndex) => (
                      <p key={pIndex}>{paragraph}</p>
                    ))}
                  </div>
                </div>
              </div>
            ))}
          </div>

          <div className="terms-footer">
            <p>
              <strong>{isEnglish ? "Last Updated:" : "Përditësuar më:"}</strong> {new Date().toLocaleDateString(isEnglish ? 'en-US' : 'sq-AL')}
            </p>
            <p>
              {isEnglish 
                ? "For additional questions about these terms, please contact us."
                : "Për pyetje shtesë rreth këtyre kushteve, ju lutemi na kontaktoni."
              }
            </p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TermsOfService; 